/** Session draft when jumping Add Issue → Add Test Case and back (keeps form + preselects new test case). */
export const ISSUE_CREATE_FORM_DRAFT_KEY = "issueCreateFormDraft";
